import { render, staticRenderFns } from "./UserCollaborationAgreementCard.vue?vue&type=template&id=00a0ee4a&"
import script from "./UserCollaborationAgreementCard.vue?vue&type=script&lang=js&"
export * from "./UserCollaborationAgreementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports